module.exports = __webpack_public_path__ + "img/1575756372.8ba42fae.jpg";